import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { ChunkErrorBoundary } from "./components/ChunkErrorBoundary";
import { getMediaBaseUrl } from "./utils/media";

// Vite fires `vite:preloadError` when a lazy chunk fails to load — almost always
// because a new deploy changed the content-hashed filenames and this tab still
// has the old index.html. Reload once to fetch fresh assets instead of leaving a
// blank page. A 10s guard prevents a reload loop if the chunk is truly gone.
window.addEventListener("vite:preloadError", (e) => {
  e.preventDefault();
  const last = Number(sessionStorage.getItem("cortex-chunk-reload-at") || 0);
  if (Date.now() - last < 10_000) return;
  sessionStorage.setItem("cortex-chunk-reload-at", String(Date.now()));
  window.location.reload();
});

// Warm the media-base cache before anything renders so the print
// preview's synchronous `getMediaBaseUrlSync()` reads a real CDN URL
// instead of the `/api/media` fallback (which would no-op the CDN
// → proxy rewrite that prevents canvas tainting in PDF capture).
getMediaBaseUrl();

// Load saved theme tokens from localStorage
try {
  const saved = localStorage.getItem("cortex-theme");
  if (saved) {
    const tokens = JSON.parse(saved);
    const root = document.documentElement;
    for (const [k, v] of Object.entries(tokens)) {
      root.style.setProperty(k, v as string);
    }
  }
} catch { /* ignore */ }

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ChunkErrorBoundary>
      <App />
    </ChunkErrorBoundary>
  </StrictMode>
);
